import React from 'react';
import PropTypes from 'prop-types';
import HtmlHead from 'client/components/htmlHead';
import { TAX_META_IMG } from '../../constants/urls';
import '../../styles/benefits.scss';

const propTypes = {
  children: PropTypes.element.isRequired,
};

const defaultProps = {};

class BenefitsApp extends React.PureComponent {
  render() {
    return (
      <div className="tax-benefits">
        <HtmlHead
          title="Stride Tax + Airbnb"
          description="Airbnb has partnered with Stride to offer you free tax assistance"
          imageUrl={TAX_META_IMG} />
        {React.Children.only(this.props.children)}
      </div>
    );
  }
}

BenefitsApp.propTypes = propTypes;
BenefitsApp.defaultProps = defaultProps;
export default BenefitsApp;
